import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import BonusScreen from '../scenes/BonusScreen';
import UIAssetKeys from '../UIAssetKeys';
import TimerDisplay from './TimerDisplay';

export default class BonusHUD extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {BonusScreen} scene 
   */
  constructor(scene, isodd) {
    super(scene);

    this.delegate = scene;

    this.totalTime = 10;

    this.lblBonus = ABCyaPhaser.Images.addImage(20,20,UIAssetKeys._Label_BonusHud, this).setOrigin(0);

    this.instructContainer = this.scene.add.container();
    let curX = 0;
    let s = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Label_PopThe, this.instructContainer).setOrigin(0);
    curX = s.x + s.width + 14;
    const sn = isodd ? UIAssetKeys._Label_Odd : UIAssetKeys._Label_Even;
    s = ABCyaPhaser.Images.addImage(curX,0,sn, this.instructContainer).setOrigin(0);
    curX = s.x + s.width + 14;
    s = ABCyaPhaser.Images.addImage(curX, 0, UIAssetKeys._Label_NumberedBalloons, this.instructContainer).setOrigin(0);

    this.instructContainer.x = this.scene.scale.width / 2 - this.instructContainer.getBounds().width / 2;
    this.instructContainer.y = this.scene.scale.height - 120;
    this.add(this.instructContainer);

    this.timeLeft = this.totalTime;

    this.timerBar = new TimerDisplay(this.scene);
    this.timerBar.x = 400;
    this.timerBar.y = 20;
    this.add(this.timerBar);
  }

  tick (deltaSeconds) {
    const d = deltaSeconds;
    this.timeLeft -= d;
    const t = this.timeLeft / this.totalTime;

    if (this.timeLeft <= 0) {
      this.delegate.timesUp();
    }
    else {
      this.timerBar.setProgress(t);
    }
  }
}